module.exports = __webpack_public_path__ + "static/media/DropOffIcon.d357dc71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/google-map/DropOffIcon.svg
// module id = 464
// module chunks = 0